module.exports = __webpack_public_path__ + "static/media/stamp-dark.e04b1c64.svg";